import { useSelector } from 'react-redux'

import { getMenuIsLoaded } from 'selectors/menu-metadata/getMenuIsLoaded'

export const useMenuIsLoaded = (): boolean => useSelector(getMenuIsLoaded)
